module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAABSUlEQVQ4jaXUPUscURQG4GfHiayQsMQPBLGJATstUqQJYpUmGLSwVCEIWmQhzGwlgr8gDoFUCZG0IW1QSJk6YJk62liICBYWKxGL2dldxok661veO/fhcObeU4mjSEFCLOI1RtGHc/zBd/zOPtxOkvaBfIbwtYXk8wpvkWALl9lGUFDJzn+QLAPYRKN7MQ+tYP4GpDsbGC+CHmDtjgg8xssiaBiTJSB4VgRNo1YSmm3EcS0Pzbnes9sy1SqgfbAfz0si8A/NDMp+eS9QH+pQiaOojo89IN1VzQR4dw8kq2o5wMQ9IXgaSPu0i4segBOcoRpiHd+whxcloU/Yx0iIz63FN/iJJ3dEDvF+O0lO6dyjKiI8KlHNID404nikGxrEqvS95dOU9iKfh9JpMU1nsB1hAUvSiRhKh9YBvuAvZqQ9HGvtH+MHfsEVGD80a6XUSuwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/qq.png
// module id = hKgE
// module chunks = 1